var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center text-muted"},[_vm._v("© Copyright 2021 Aerialoop")])}
var staticRenderFns = []

export { render, staticRenderFns }